import { Sparkles } from "lucide-react";

/**
 * PlaceholderPage — shared "Próximamente" surface for drawer destinations that
 * don't have their real feature yet (Negocios / Market / Rincón Latino).
 *
 * Uses only the icon and a one-line description — no live data, no GPS/maps.
 */
export default function PlaceholderPage({ title, description, icon: Icon, testIdSlug }) {
  return (
    <main
      className="min-h-screen pt-24 pb-32 px-4 sm:px-6"
      data-testid={`page-${testIdSlug}`}
    >
      <div className="max-w-2xl mx-auto">
        <div className="q-glass border border-white/10 rounded-3xl p-8 sm:p-10 text-center relative overflow-hidden">
          {/* soft accent glow */}
          <div
            aria-hidden="true"
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "radial-gradient(600px circle at 50% -20%, var(--accent-soft), transparent 60%)",
              opacity: 0.55,
            }}
          />
          <div
            className="relative mx-auto mb-5 flex items-center justify-center h-16 w-16 rounded-2xl"
            style={{
              background: "var(--accent-soft)",
              border: "1px solid rgba(0, 240, 255, 0.35)",
              boxShadow: "0 0 30px var(--accent-soft)",
            }}
          >
            {Icon ? <Icon size={30} className="q-accent-text" strokeWidth={2.2} /> : null}
          </div>

          <span
            className="relative inline-flex items-center gap-1 rounded-full px-3 py-1 text-[10px] uppercase font-mono tracking-[0.22em] mb-3"
            style={{
              border: "1px solid rgba(0, 240, 255, 0.35)",
              color: "#00f0ff",
              background: "rgba(0, 240, 255, 0.08)",
            }}
            data-testid={`page-${testIdSlug}-badge`}
          >
            <Sparkles size={11} /> Próximamente
          </span>

          <h1
            className="relative font-display text-3xl sm:text-4xl font-bold tracking-tight mb-3"
            data-testid={`page-${testIdSlug}-title`}
          >
            {title}
          </h1>
          <p
            className="relative text-sm sm:text-base text-slate-300 leading-relaxed max-w-md mx-auto"
            data-testid={`page-${testIdSlug}-description`}
          >
            {description}
          </p>
        </div>
      </div>
    </main>
  );
}
